<template>
    <div class="printOrderListBox">
        <el-tabs v-model="orderStatusValue" class="orderListTabs" @tab-click="searchInfo">
            <el-tab-pane v-for="item in tabList" :key="item.id" :label="item.name" :name="item.id">
            </el-tab-pane>
        </el-tabs>
        <div>
            <div class="orderSearchBox">
                <!--<el-date-picker
                    v-model="createDateValue"
                    clearable
                    type="date"
                    placeholder="区间筛选">
                </el-date-picker>-->
                 <div class="timeSearch">
                    <span style="color: #b2b2b2;">区间筛选</span>
                     <el-date-picker
                        v-model="createDateValue"
                        @change="chooseDate"
                        type="daterange"
                         value-format="yyyy-MM-dd"
                        range-separator="—"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期"
                        >
                    </el-date-picker>
                </div>
                <el-cascader
                    v-model="materialsValue"
                    clearable
                    :options="material_printList"
                    :props="props"
                    placeholder="材料分类"></el-cascader>
                <el-input v-model="buyerName" placeholder="服务商名称"></el-input>
                <el-input v-model="orderNo" placeholder="订单编号"></el-input>
                <!-- <el-select v-model="evaluateStatusValue" clearable placeholder="评价状态">
                    <el-option
                        label="已评价"
                        value="已评价">
                    </el-option>
                    <el-option
                        label="待评价"
                        value="待评价">
                    </el-option>
                </el-select> -->
                <!-- <el-select v-model="postSalesServiceValue" clearable placeholder="售后服务">
                    <el-option
                        label="仅退款"
                        value="仅退款">
                    </el-option>
                    <el-option
                        label="退款退货"
                        value="退款退货">
                    </el-option>
                    <el-option
                        label="换货"
                        value="换货">
                    </el-option>
                </el-select> -->
                <el-button class="searchBtn" @click="searchInfo">搜索</el-button>
                <el-button type="text" class="resetBtn" @click="clearSearch">
                    <i class="iconfont icon-qingchushujuku"></i>
                    <span>清除条件</span>
                </el-button>
            </div>
            <div class="orderListTable">
                <!-- <div class="tableTool">
                    <div class="toolLeft">
                        <span>已选： <span class="num">{{multipleSelection.length}}</span></span>
                        <el-button type="primary" plain size="small" :disabled="multipleSelection.length<=0">批量发货</el-button>
                        <el-button type="primary" plain size="small" :disabled="multipleSelection.length<=0">批量免运费</el-button>
                        <el-button type="primary" plain size="small" :disabled="multipleSelection.length<=0">导出订单</el-button>
                    </div>
                </div> -->
                <ul class="tableHeader">
                    <li class="select">
                        <el-checkbox v-model="checkedAll"  @change="tableHeaderChange">全选</el-checkbox>
                    </li>
                    <li class="name">打印模型</li>
                    <li class="price">单价</li>
                    <li class="num">数量</li>
                    <li class="arguments">打印参数</li>
                    <li class="payment">实付款</li>
                    <li class="status">交易状态</li>
                    <li class="status">开票状态</li>
                    <li class="operation">操作</li>
                </ul>
                <ul class="tableBody" v-if="tableList.length != 0" v-loading="loading">
                    <li class="bodyItem" v-for="item in tableList">
                        <div class="itemTop">
                            <el-checkbox v-model="item.checked" style="padding-right: 20px;"  @change="bodyItemCheckChange"></el-checkbox>
                            <div>订单编号：{{item.orderBase.orderNo}}</div>
                            <div>创建时间：{{item.orderBase.createDate}}</div>
                            <div class="merchantInfo">
                                <span>服务商：</span>
                                <span>{{item.enterPriseName}}</span>
                                <i class="iconfont icon-weixin" @click="startChat(item.enterPriseId)"></i>
                            </div>
                            <!--<el-button type="text" class="complainBtn">投诉商家</el-button>-->
                        </div>
                        <div class="itemBottom">
                            <div class="name">
                                <div>
                                    <div class="orderInfo" v-for="(info,index) in item.list" :key="index">
                                        <!-- <img :src="info.url" alt=""> -->
                                        <div class="imgThree demo-block-preview">
                                            <model-stl
                                                :backgroundAlpha="0"
                                                :rotation="rotation"
                                                :src="info.url.toLowerCase()">
                                            </model-stl>
                                        </div>
                                        <el-button class="preview" @click="handPreview(info)">预览</el-button>
                                        <div class="infoContent">
                                            <div class="infoName" :title="info.name">{{info.name}}</div>
                                            <div class="infoOther">表面积：{{info.longSize}}*{{info.widthSize}}*{{info.heightSize}}cm</div>
                                            <div class="infoOther">体&nbsp;&nbsp;积：{{info.volume}}mm³</div>
                                            <div class="infoOther">缩&nbsp;&nbsp;放：{{info.scale}}%</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="price">
                                <div v-for="(price,index) in item.list" :key="index"  style="line-height: 144px;">¥{{price.unitPrice}}</div>
                            </div>
                            <div class="num">
                                <div v-for="(printNum,index) in item.list" :key="index"  style="line-height: 144px;">{{printNum.printNum}}</div>
                            </div>
                            <div class="arguments">
                                <div>
                                    <div class="argumentsName">工&nbsp;&nbsp;艺：{{item.technologyName}}</div>
                                    <div class="argumentsName">材&nbsp;&nbsp;料：{{item.firstMaterialName}}/{{item.secondMaterialName}}</div>
                                    <div class="argumentsName">填&nbsp;&nbsp;充：{{item.soildUuid=='YES'?'空心':'实心'}}</div>
                                    <div class="argumentsName" v-if="item.isReprocess=='YES'">后处理：{{item.typeName}}&nbsp;|&nbsp;{{item.surfaceEffectName}}</div>
                                </div>
                            </div>
                            <div class="payment">
                                <h3>¥{{item.orderBase.totalPrice}}</h3>
                                <div class="title">(含运费：{{item.transportationPrice}}元)</div>
                            </div>
                            <div class="status">
                                <div class="statusName">{{item.orderBase.orderStatusCn}}</div>
                                <el-button type="text" class="operationBtn" @click="toDetail(item)">订单详情</el-button>
                                <el-button type="text" class="operationBtn" v-if="item.isShipments === '1'">查看物流</el-button>
                            </div>
                            <div class="status">
                                <div>{{ item.issueInvoiceType==null?"未开票":item.issueInvoiceType=="EXAMINE"?'开票中':item.issueInvoiceType=='PASS'?'已开票':'已拒绝' }}</div>
                            </div>
                            <div class="operation">
                                <el-button type="text" class="operationUploadBtn"
                                           v-if="item.orderBase.orderStatus === 'UN_CONFIRM'"
                                           @click="updateAddress(item)">修改地址
                                </el-button>
                                <el-button type="text" class="operationUploadBtn"
                                           v-if="item.orderBase.orderStatus === 'UN_CONFIRM' || item.orderBase.orderStatus === 'UN_PAY' || item.orderBase.orderStatus == 'OFFLINE_UN_CONFIRM' || item.orderBase.orderStatus == 'DELIVERY_ON_CASH_UN_CONFIRM'"
                                           @click="cancelOrder(item)">取消订单
                                </el-button>
                                <el-button type="text" class="operationUploadBtn"
                                           v-if="item.orderBase.orderStatus === 'UN_PAY'" @click="submitPay1(item)">付款
                                </el-button>
                                <el-button type="text" class="operationUploadBtn"
                                           v-if="item.orderBase.orderStatus === 'UN_RECEIVE'"
                                           @click="takeDelivery(item)">收货
                                </el-button>
                                <el-button type="text" class="operationUploadBtn"
                                           v-if="item.orderBase.orderStatus === 'UN_APPRAISE'"
                                           @click="evaluateInfo(item)">评价
                                </el-button>
                                <el-button type="text" class="operationUploadBtn"
                                           v-if="item.orderBase.orderStatus !== 'UN_CONFIRM'
                                && item.orderBase.orderStatus !== 'UN_PAY'
                                && item.orderBase.orderStatus !== 'UN_CANCEL'
                                && item.orderBase.orderStatus !== 'OFFLINE_UN_CONFIRM'
                                && item.orderBase.orderStatus !== 'DELIVERY_ON_CASH_UN_CONFIRM'
                                && (item.orderBase.afterSaleUuid===null || (item.orderBase.afterSaleUuid!==null&&item.orderBase.afterSaleAuditStatus==='REJECT'))
                                && item.orderBase.splitStatus === 'NONE'
                                && item.orderBase.orderStatus !== 'AFTER_SALES'"
                                           @click="AfterSales(item.orderBase.uuid,item.enterPriseId,item.enterPriseName,item.orderBase.orderStatus,item.orderBase.totalPrice)">
                                    申请售后
                                </el-button>
                                <!-- <el-button type="text" class="operationUploadBtn" @click="AfterSales">申请售后</el-button> -->
                                <el-button type="text" class="operationUploadBtn"
                                           v-if="item.orderBase.orderStatus !== 'UN_CONFIRM'
                                           && item.orderBase.orderStatus !== 'UN_PAY'
                                && item.orderBase.orderStatus !== 'UN_CANCEL'
                                && item.orderBase.orderStatus !== 'DELIVERY_ON_CASH_UN_CONFIRM'
                                && item.issueInvoiceType == null
                                && item.orderBase.afterSaleAuditStatus !== 'PASS'
                                && item.orderBase.orderStatus !== 'AFTER_SALES'"
                                           @click="openInvoice(item)">申请开票
                                </el-button>
                                <el-button type="text" class="operationUploadBtn"
                                           v-if="item.orderBase.orderStatus == 'OFFLINE_UN_CONFIRM'
                                           || item.orderBase.orderStatus === 'UN_SEND'
                                           || item.orderBase.orderStatus === 'UN_RECEIVE'
                                           || item.orderBase.orderStatus === 'UN_APPRAISE'
                                           || item.orderBase.orderStatus === 'AFTER_SALES'
                                           || item.orderBase.orderStatus === 'FINISHED'"
                                           @click="complain(item.orderBase.uuid,item.enterPriseId,item.enterPriseName)">
                                    投诉
                                </el-button>
                                <!--                                <el-button type="text" class="operationUploadBtn" @click="dialogVisibleDialog = true">投诉</el-button>-->
                                <!--                                <el-button type="text" class="operationUploadBtn" @click="complain(item.orderBase.uuid,item.enterPriseId,item.enterPriseName)">投诉</el-button>-->
                            </div>
                        </div>
                    </li>
                </ul>
                <!-- <div class="orderNomesaage" v-loading="loading" v-else >暂无数据</div> -->
                <div class="orderNomesaage" v-loading="loading" v-else >
                    <img src="../../../assets/暂无订单.jpg" alt="" style="width:200px">
                </div>
            </div>
            <el-pagination
                v-if="tableList.length != 0"
                background
                @current-change="handleCurrentChange"
                @prev-click="handleCurrentChange"
                @next-click="handleCurrentChange"
                layout="total,prev, pager, next,jumper"
                :current-page="current"
                :page-size="pageSize"
                :total="total" class="pagination">
            </el-pagination>
        </div>
        <!--发话输入物流信息弹出框-->
        <el-dialog
            title="取消订单"
            :visible.sync="cancelDialogVisible"
            :close-on-click-modal="false"
            width="1000px">
            <div class="logisticsDialog">
                <el-form ref="logisticsForm" :rules="cancelRules" class="demo-ruleForm">
                    <el-form-item class="addressList">
                        <el-select v-model="cancelUuid" placeholder="取消原因">
                            <el-option v-for="(item,index) in cancelList" :key="index"
                                :label="item.name"
                                :value="item.uuid">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item class="submitButtonGroup">
                        <el-button type="primary" @click="cancelSubmit">确定</el-button>
                        <el-button @click="cancelDialogVisible = false">取消</el-button>
                    </el-form-item>
                </el-form>
            </div>
        </el-dialog>
        <!--评价弹出框-->
        <el-dialog title="评价" :visible.sync="evaluateDialogVisible" width="500px">
            <div class="evaluateDialogBox">
                <div class="evaluateItem">
                    <div class="name">评价等级</div>
                    <div class="content">
                        <div class="rateItem">
                            <div class="name">描述相符</div>
                            <el-rate
                                v-model="evaluateForm.descriptionPoint"
                                show-score
                                text-color="#ff9900"
                            >
                            </el-rate>
                        </div>
                        <div class="rateItem">
                            <div class="name">服务态度</div>
                            <el-rate
                                v-model="evaluateForm.servicePoint"
                                show-score
                                text-color="#ff9900"
                            >
                            </el-rate>
                        </div>
                        <div class="rateItem">
                            <div class="name">专业程度</div>
                            <el-rate
                                v-model="evaluateForm.transportPoint"
                                show-score
                                text-color="#ff9900"
                            >
                            </el-rate>
                        </div>
                    </div>
                </div>
                <div class="evaluateItem">
                    <div class="name">评价标签</div>
                    <div class="content">
                        <el-checkbox-group
                            v-model="evaluateForm.evaluationTagList"
                            class="evaluateTag"
                        >
                            <el-checkbox-button
                                v-for="tag in tagList"
                                :label="tag"
                                :key="tag.tagUuid"
                            >{{ tag.tagName }}</el-checkbox-button
                            >
                        </el-checkbox-group>
                    </div>
                </div>
                <div class="evaluateItem">
                    <div class="name">评价内容</div>
                    <div class="content">
                        <el-input
                            type="textarea"
                            :autosize="{ minRows: 6 }"
                            placeholder="请输入内容"
                            v-model="evaluateForm.evaluationContent"
                        >
                        </el-input>
                    </div>
                </div>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="evaluateDialogVisible = false">取 消</el-button>
                <el-button type="primary" :disabled="stepLoading" @click="evaluateSubmit">确 定</el-button>
            </span>
        </el-dialog>
        <!-- 申请开票 -->
        <issue-invoice-dialog ref="invoiceDialogRef"></issue-invoice-dialog>
        <!-- 购买的弹窗 -->
        <PayModelDialog ref="payModelRef" @refreshData="getPrintOrderList"/>
        <!--修改地址-->
        <edit-address ref="editAddressRef" @editAddressSuccess="getPrintOrderList"></edit-address>
        <!-- 投诉弹窗 -->
        <complaints-dialog
            ref="dialogRef"
        ></complaints-dialog>
        <!-- 申请售后 -->
        <after-sales-dialog
            ref="afterSalesDialog"
        ></after-sales-dialog>
        <!-- 3d预览 -->
        <three-d
            ref="threeBox"
            :innerVisible="innerVisible"
            :fileListNew="fileListNew"
            @closeDlog="closeDlog"
        ></three-d>

        <!--聊天窗口-->
        <chat-dialog ref="chatDialogRef"></chat-dialog>
        <!-- 付款方式 -->
        <TermsOfPayment ref="termsOfPaymentRef" @offlinePay="offlinePayOrder"/>
    </div>
</template>

<script>
import {
    getPrintOrderList, getDictionaryGroup, findTypeListByGroupUuid,
    getDictionaryItem, updateOrderBaseInfo, updateBuyerPrintOrder, saveEvaluation, getRongCloudUser, offlinePay, deliveryOnCash,
} from '../../../utils/interface';
import editAddress from './editAddress'
import complaintsDialog from './complaintsDialog'
import afterSalesDialog from './afterSalesDialog'
import threeD from "../../../components/threeD/index"
import issueInvoiceDialog from "./issueInvoiceDialog"
import PayModelDialog from "./payModelDialog"
import chatDialog from "../../../components/chat/chatDialog";
import ModelStl from 'vue-3d-model/src/model-stl'
import TermsOfPayment from '../../../components/termsOfPayment/termsOfPayment'
export default {
    name: "printOrderList",
    data() {
        return {
            stepLoading: false,
            loading: true,
            order:{},
            tabList: [
                {
                    id: "ALL",
                    name: "全部",
                },
                {
                    id: "UN_CONFIRM",
                    name: "待确认",
                },
                {
                    id: "UN_PAY",
                    name: "待付款",
                },
                {
                    id: "OFFLINE_UN_CONFIRM",
                    name: "线下支付待确认",
                },
                {
                    id: "DELIVERY_ON_CASH_UN_CONFIRM",
                    name: "货到付款待确认",
                },
                {
                    id: "UN_SEND",
                    name: "待发货",
                },
                {
                    id: "UN_RECEIVE",
                    name: "待收货",
                },
                {
                    id: "UN_APPRAISE",
                    name: "待评价",
                },
                {
                    id: "UN_CANCEL",
                    name: "已取消",
                },
            ],
            createDateValue: null,
            startTime:"",
            endTime:"",
            materialsValue: '',
            material_printList:[],
            props: {
                value: 'uuid',
                label: 'name',
                //lazy: true,
                checkStrictly: true,
                //lazyLoad: this.cascaderLazyLoad
            },
            buyerName: '',
            orderNo: '',
            orderStatusValue: "ALL",
            // evaluateStatusValue: '',
            // postSalesServiceValue: '',
            trackingNumber: '',
            multipleSelection: [],
            checkedAll: false,
            tableList: [],
            current: 1,
            total: 0,
            pageSize: 8,
            // 修改地址
            addressDialogVisible:false,
            takeOverUuid:"",
            printOrderUuid:"",
            addressList:"",
            // 取消订单
            cancelDialogVisible:false,
            cancelList:[],
            cancelUuid:"",
            orderBaseUuid:"",
            cancelRules: {
                cancelUuid:[
                    {required: true, message: '请选择取消原因', trigger: 'change'}
                ]
            },
            // 评价
            evaluateDialogVisible: false,
            evaluateForm: {
                descriptionPoint: 0,
                servicePoint: 0,
                transportPoint: 0,
                evaluationTagList: [],
                evaluationContent: "",
            },
            tagList: [],
            dialogVisibleDialog: false,
            editPriceDialogVisible: false,
            // 3D预览
            fileListNew: [],
            innerVisible: false,
            rotation: {
                x: 200,
                y: 0,
                z: 100,
            },
        }
    },
    components: {
        editAddress,
        complaintsDialog,
        afterSalesDialog,
        threeD,
        issueInvoiceDialog,
        PayModelDialog,
        chatDialog,
        ModelStl,
        TermsOfPayment
    },
    created(){
        this.getPrintOrderList();
        this.getDictionaryList('material_print');
        this.getDictionaryItem();
    },
    mounted(){
        // this.snapshot()
    },
    methods: {
        // snapshot() {
        //     this.base64img = this.$refs.model[0].renderer.domElement.toDataURL('image/png', 1);
        // },
        searchInfo(){
            this.current = 1;
            this.getPrintOrderList();
        },
        clearSearch(){
            this.orderStatusValue = "";
            this.buyerName = "";
            this.orderNo = "";
            this.materialsValue = "";
            this.createDateValue = null;
            this.startTime = "";
            this.endTime = "";
            // this.evaluateStatusValue = "";
            // this.postSalesServiceValue = "";
            this.trackingNumber = "";
            this.searchInfo();
        },
        // 获取字典值列表
        getDictionaryList(val){
            getDictionaryGroup({parentCode:val}).then((res)=>{
                res.map((item)=>{
                    findTypeListByGroupUuid({groupUuid:item.uuid}).then((res)=>{
                        if(res){
                            item.children = res.data;
                        }
                    })
                });
                this.material_printList = res;
            });
            /*getDictionaryGroup({parentCode:val}).then((res)=>{
                if(val === 'material_print'){
                    this.material_printList = res
                }
            })*/
        },
        // 获取字典值
        getDictionaryItem() {
            getDictionaryItem({groupCode: "print_evaluation_tag"}).then((res) => {
                this.tagList = [];
                res.forEach((item, index) => {
                    this.tagList.push({tagName: item.name, tagUuid: item.code, tagGroupId: item.groupUuid});
                });
            });
        },
        getPrintOrderList(){
            this.loading = true
            let params = {
                orderNo:this.orderNo,
                buyerName:this.buyerName,
                isBuy:true,
                firstMaterialUuid:this.materialsValue.length>=1?this.materialsValue[0]:'',
                materialUuid:this.materialsValue.length==2?this.materialsValue[1]:'',
                orderStatus:this.orderStatusValue=="ALL"?"":this.orderStatusValue,
                //createDate:this.createDateValue==null?null : this.createDateValue.getFullYear() +'-'+ (this.createDateValue.getMonth() + 1) +'-'+this.createDateValue.getDate(),
                startDate:this.startTime,
                endDate:this.endTime,
                // appraiseStatus:this.evaluateStatusValue,
                // serverStatus:this.postSalesServiceValue,
                logisticsNo:this.trackingNumber,
                current:this.current,
                pageSize:this.pageSize,
            };
            getPrintOrderList(params).then((res)=>{
                this.current = res.current;
                this.total = res.total;
                this.tableList = res.data;
                this.loading = false
            });
        },
        // 表单数字校验
        validatorNum(rule, value, callback){
            if(rule.field === 'printPrice'){
                if (value === '') {
                    callback(new Error('请输入打印总价'))
                } else if (!/^\d+(\.\d+)?$/.test(value)) {
                    callback(new Error('请输入数字'))
                } else {
                    callback()
                }
            }
            if(rule.field === 'freightPrice'){
                if (value === '') {
                    callback(new Error('请输入运费'))
                } else if (!/^\d+(\.\d+)?$/.test(value)) {
                    callback(new Error('请输入数字'))
                } else {
                    callback()
                }
            }
            if(rule.field === 'sizePrecision'){
                if (value === '') {
                    callback(new Error('请输入尺寸精度'))
                } else if (!/^\d+(\.\d+)?$/.test(value)) {
                    callback(new Error('请输入数字'))
                } else {
                    callback()
                }
            }
            if(rule.field === 'orderPrice'){
                if (value === '') {
                    callback(new Error('请输入订单总价'))
                } else if (!/^\d+(\.\d+)?$/.test(value)) {
                    callback(new Error('请输入数字'))
                } else {
                    callback()
                }
            }
        },
        // 申请售后
        AfterSales(orderBaseUuid, targetUserUuid, enterPriseName, orderStatus, orderPrice){
            this.$refs.afterSalesDialog.init(orderBaseUuid, targetUserUuid, enterPriseName, 'PRINT', orderStatus, orderPrice)
        },
        // 修改价格
        editPrice(){
            this.editPriceDialogVisible = true
            this.editPriceForm = {
                printPrice: '',
                freightPrice: '',
                orderPrice: ''
            }
            if(this.$refs.editPriceForm){
                this.$refs.editPriceForm.clearValidate()
            }
        },
        // 修改价格提交
        submit(){
            this.$refs.editPriceForm.validate((valid) => {
                if (valid) {
                    this.editPriceDialogVisible = false
                    this.$message.success('修改成功！')
                } else {
                    return false;
                }
            })
        },
        // 列表选择功能
        tableHeaderChange(val){
            this.tableList.map(item=>{
                item.checked = val
            });
            if(val){
                this.multipleSelection = this.tableList
            } else {
                this.multipleSelection = []
            }
        },
        bodyItemCheckChange(){
            this.multipleSelection = this.tableList.filter(res => res.checked === true)
            if(this.multipleSelection.length === this.tableList.length){
                this.checkedAll = true
            } else {
                this.checkedAll = false
            }
        },
        //级联选择器  获取二级数据
        cascaderLazyLoad(node,resolve) {
            const { level } = node;   //获取层级
            const {children} = node;    //花括号写法 表示直接取到对象里的某个属性
            const {data} = node;
            let parentId = data?data.id:"0";
            //如果不是根级菜单
            if(!node.root) {
                getDictionaryItem({groupCode: node.data.code}).then((res)=>{
                    let nodes = [];
                    if (res) {
                        for (let item of res) {
                            nodes.push({
                                uuid: item.uuid,
                                name: item.name,
                                remarks: item.remarks,
                                leaf:level <= 2               //设置能加载到的层级  此处只能加载2级
                            })
                        }
                    }
                    resolve(nodes);    //将组装好的数据暴露
                })
            }
        },
        // 分页
        handleCurrentChange(val) {
            this.current = val;
            this.getPrintOrderList();
        },
        // 时间格式
        chooseDate(){
            this.startTime = "";
            this.endTime = "";
            // 判断时间
            if(this.createDateValue!=null && this.createDateValue.length==2){
                this.startTime = this.timeDate(this.createDateValue[0]);
                this.endTime = this.timeDate(this.createDateValue[1]);
            }
        },
        timeDate(value){
            let date = new Date(value);
            let y = date.getFullYear();
            let MM = date.getMonth() + 1;
            MM = MM < 10 ? "0" + MM : MM;
            let d = date.getDate();
            d = d < 10 ? "0" + d : d;
            return y + "-" + MM + "-" + d;
        },
        // 跳转至详情页
        toDetail(val){
            this.$router.push({name:'printOrderDetails',params:{uuid:val.uuid}});
        },
        updateAddress(item){
            this.$refs.editAddressRef.init(item.printOrderUuid,item.takeOverUuid)
        },
        // 取消
        cancelOrder(item){
            getDictionaryItem({groupCode:"print_cancel_reason"}).then((res)=>{
                this.cancelList = res;
                this.printOrderUuid = item.printOrderUuid;
                this.orderBaseUuid = item.orderBase.uuid;
                this.cancelDialogVisible = true;
            });
        },
        cancelSubmit(){
            if(this.cancelUuid==""){
                this.$message.error('请选择取消原因！');
                return false;
            }
            updateOrderBaseInfo({uuid:this.orderBaseUuid,orderStatus:"UN_CANCEL",cancelOrderUuid:this.cancelUuid}).then((res)=>{
                if(res.success){
                    updateBuyerPrintOrder({uuid:this.printOrderUuid,orderStatus:"UN_CANCEL"}).then((result)=>{
                        if(result.success){
                            this.$message.success('订单取消成功！');
                            this.cancelUuid = "";
                            this.cancelDialogVisible = false;
                            this.getPrintOrderList();
                        }
                    });
                }
            });
        },
        submitPay1(item){
            this.order = item;
            // 付款的选择弹窗
            this.$refs.termsOfPaymentRef.init(item)

            // this.$refs.payModelRef.init();
            // window.open(this.$url.payUrl + item.orderBase.orderNo, "_blank");
        },
        // 支付
        /*submitPay(item){
            updateOrderBaseInfo({uuid:item.orderBase.uuid,orderStatus:"UN_SEND"}).then((res)=>{
                if(res.success){
                    this.$message.success('订单支付成功！');
                    this.getPrintOrderList();
                }
            });
        },*/
        // 收货
        takeDelivery(item){
            this.$confirm('是否确认收货?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                item.orderBase.orderStatus = "UN_APPRAISE";
                updateOrderBaseInfo(item.orderBase).then((res)=>{
                    if(res.success){
                        this.$message.success('收货成功！');
                        this.getPrintOrderList();
                    }
                });

            });
        },

    // 点击打开评价弹出框
    evaluateInfo(order) {
        this.order = order;
        this.evaluateForm = {
            descriptionPoint: 0,
            servicePoint: 0,
            transportPoint: 0,
            evaluationTagList: [],
            evaluationContent: "",
        };
        this.evaluateDialogVisible = true;
    },
    evaluateSubmit(){
        this.stepLoading = true;
        if (
            this.evaluateForm.descriptionPoint &&
            this.evaluateForm.servicePoint &&
            this.evaluateForm.transportPoint
        ) {
            this.evaluateForm.orderNo = this.order.orderBase.orderNo;
            this.evaluateForm.orderUuid = this.order.uuid;
            this.evaluateForm.orderType = 'PRINT';
            this.evaluateForm.evaluationType = 'NORMAL';
            this.evaluateForm.sellerName = this.order.enterPriseName;
            this.evaluateForm.sellerUuid = this.order.enterPriseId;
            if(this.order.list.length > 0){
                this.evaluateForm.orderName = this.order.list[0].name;
            }
            this.evaluateForm.orderAmount = this.order.orderBase.totalPrice;

                saveEvaluation(this.evaluateForm).then((response) => {
                    if (response.success) {
                        this.evaluateDialogVisible = false;
                        this.getPrintOrderList();
                        this.$message({
                            type: "success",
                            message: "评价成功",
                        });
                    } else {
                        this.$message({
                            type: "error",
                            message: response.message,
                        });
                    }
                    this.order = {};
                });
            } else {
                this.$message.warning("请选择评价等级");
            }
        setTimeout(() => {
            this.stepLoading = false;
        }, 1000);
        },
        // 申请开票
        openInvoice(item){
            let params = {uuid:item.issueInvoiceUuid,
                orderUuid:item.orderBaseUuid,
                orderNo:item.orderBase.orderNo,
                orderName:item.list[0].name,
                orderImg:item.list[0].url,
                orderType:'PRINT',
                issueUser:item.userUuid,
                invoiceMoney:item.orderBase.totalPrice,
            }
            console.log("params=="+JSON.stringify(params))
            this.$refs.invoiceDialogRef.init(params);
        },

        complain(orderBaseUuid, targetUserUuid, enterPriseName) {
            this.$refs.dialogRef.init(orderBaseUuid, targetUserUuid, enterPriseName);
        },
        // 预览模型
        handPreview(info) {
            this.$refs.threeBox.threeAnimal(info);
            this.innerVisible = !this.innerVisible;
        },
        closeDlog(index){
            this.innerVisible = index;
        },
        startChat(targetUuid) {
            let user = this.$store.state.userMessages;
            getRongCloudUser(targetUuid).then(res=> {
                console.log(res);
                this.$refs.chatDialogRef.init(user.uuid,user.name,user.headUrl,res.uuid,res.name,res.headUrl);
            });
        },
        //线下支付上传凭证
        offlinePayOrder(obj){
            if(obj.radio == 1){
                this.$refs.payModelRef.init();
                window.open(this.$url.payUrl + this.order.orderBase.orderNo, "_blank");
            } else if(obj.radio == 2 && obj.imageUrl != '' && obj.imageUrl != null){
                let form ={orderNo: this.order.orderBase.orderNo, orderBaseUuid: this.order.orderBase.uuid, payTicket: obj.imageUrl};
                offlinePay(form).then(res=> {
                    console.log(res);
                    if (res && res.success) {
                        this.$message.success(res.message);
                        this.getPrintOrderList();
                    }else {
                        this.$message.error(res.message);
                    }
                    this.order = {};
                });
            } else if(obj.radio == 3){
                let form ={orderNo: this.order.orderBase.orderNo, orderBaseUuid: this.order.orderBase.uuid};
                deliveryOnCash(form).then(res=> {
                    console.log(res);
                    if (res && res.success) {
                        this.$message.success(res.message);
                        this.getPrintOrderList();
                    }else {
                        this.$message.error(res.message);
                    }
                });
            }
        }
    }
}
</script>

<style scoped lang="less">
    .printOrderListBox {
        padding: 94px 20px 20px;
        .orderListTabs{
            position: absolute;
            left: 0;
            top: 0;
            z-index: 999;
            background: #fff;
            width: 100%;
            padding: 20px;
        }
        /deep/ .el-tabs__item {
            padding: 0 25px !important;
            text-align: center;

            &:hover {
                color: #3686d7
            }

            &:after {
                content: "";
                position: absolute;
                right: 0;
                bottom: 12px;
                width: 1px;
                height: 15px;
                background-color: #E4E7ED;
                z-index: 1;
            }

            &:last-child:after {
                content: "";
                width: 0;
                height: 0;
            }
        }
        /deep/ .el-tabs__active-bar {
            height: 3px;
            background-color: #3686d7;
        }
        /deep/ .el-tabs__item.is-active {
            color: #3686d7
        }
        /deep/ .el-tabs__nav-wrap::after {
            height: 1px;
        }
        .orderSearchBox {
            display: flex;
            flex-wrap: wrap;
            align-items: center;

            .timeSearch{
                background-color:#f2f4f7;
                height: 35px;
                display: flex;
                align-items: center;
                margin-bottom: 22px;
                margin-right: 30px;
                border-radius: 8px;
                span{
                    font-size: 12px;
                    color: #c0c4cc!important;
                    font-weight: normal;
                    padding-left: 15px;
                    margin-right: 5px;
                }
                // /deep/ .el-range-input{
                //         background-color: #f2f4f7;
                //             &:hover, &:focus {
                //             background-color: #fff;
                //             // border: 1px solid #108EE9;
                //         }
                // }
                /deep/input::-webkit-input-placeholder {
                    color: #c0c4cc;
                    font-size: 12px;
                }
              /deep/.el-range-input:hover{
                  background-color: #fff!important;
              }
              /deep/ .el-date-editor .el-range-separator{
                  line-height: 25px;
                  color: #c0c4cc;
              }
             /deep/ .el-date-editor .el-range__close-icon{
                 line-height: 28px;
             }
              /deep/ .el-input__inner:hover  .el-range-input, /deep/ .el-input__inner:focus  .el-range-input{
                  background-color: white;
              }
                /deep/ .el-input__inner {
                width: 225px;
                height: 35px;
                min-height: 35px;
                font-size: 12px;
                color: #999999;
                background-color: #f2f4f7;
                border: 1px solid #f2f4f7;
                border-radius: 5px;
                .el-range-input{
                    background-color:#f2f4f7 ;
                }

                &:hover, &:focus {
                    background-color: #fff;
                    border: 1px solid #108EE9;

                }
            }
            /deep/ .el-icon-date:before {
                    content: "\E78E";
                    display: none;
                }
                /deep/.el-input__icon{
                    // display: none;
                }
            }
            /deep/ .el-input {
                width: initial;
                margin-bottom: 22px;
                margin-right: 30px;
            }
            /deep/.el-input__suffix-inner .el-icon-circle-close{
                line-height: 32px;
            }
            /deep/ .el-input__inner {
                width: 242px;
                height: 35px;
                min-height: 35px;
                font-size: 12px;
                color: #999999;
                background-color: #f2f4f7;
                border: 1px solid #f2f4f7;
                border-radius: 5px;

                &:hover, &:focus {
                    background-color: #fff;
                    border: 1px solid #108EE9;
                }
            }

            /deep/ .el-input__prefix {
                top: -3px;
            }

            /deep/ .el-input__suffix {
                top: 2px;
            }

            /deep/ .el-button {
                display: block;
                line-height: 35px;
                padding: 0;
                height: 35px;
            }

            .searchBtn {
                width: 82px;
                background: #3d7fff;
                border: none;
                border-radius: 15px;
                font-size: 14px;
                color: #FFFFFF;
                margin-bottom:22px;
            }

            .resetBtn {
                color: #333333;
                margin-bottom:22px;
            }
        }
        .orderListTable {
            .orderNomesaage {
                color: #888;
                text-align: center;
                padding: 15px 0;
            }
            .tableTool {
                display: flex;
                justify-content: space-between;
                align-items: center;
                margin-bottom: 20px;

                .toolLeft {
                    font-size: 12px;
                    color: rgba(0, 0, 0, 0.847);

                    .num {
                        color: #356FDF;
                    }

                    button {
                        padding: 0;
                        margin-left: 15px;
                        width: 80px;
                        height: 30px;
                        background: rgba(242, 244, 247, 1);
                        box-sizing: border-box;
                        border: 1px solid rgba(21, 126, 251, 1);
                        border-radius: 5px;
                        font-size: 12px;
                        color: #157EFB;
                        line-height: 30px;
                        text-align: center;

                        &:hover {
                            background: #157EFB;
                            box-sizing: border-box;
                            border: 1px solid #157EFB;
                            color: #fff;
                        }
                    }
                }

                .toolRight {
                    button {
                        width: 83px;
                        height: 30px;
                        background: rgba(21, 126, 251, 1);
                        border: none;
                        border-radius: 15px;
                        font-size: 13px;
                        color: #fff;

                        i {
                            padding-right: 5px;
                        }

                        &:hover {
                            background: #61a2f0;
                        }
                    }
                }
            }
            .tableHeader {
                display: flex;
                width: 100%;
                height: 35px;
                line-height: 35px;
                background: #f3f7ff;
                border-radius: 5px;
                margin: 0 0 15px;

                li {
                    text-align: center;
                    font-size: 14px;
                    color: rgba(0, 0, 0, 0.85);
                }
            }
            .select{
                padding: 0 20px;
            }
            .tableBody {
                li {
                    width: 100%;
                    border: 1px solid #f2f2f2;
                    border-radius: 10px;

                    .itemTop {
                        width: 100%;
                        height: 42px;
                        background: #ebf3fb;
                        line-height: 42px;
                        font-size: 14px;
                        color: #333;
                        padding: 0 20px;
                        display: flex;
                        align-items: center;
                        position: relative;

                        div {
                            margin-right: 30px;
                        }

                        .merchantInfo {
                            display: flex;
                            align-items: center;

                            i {
                                color: #3d7fff;
                                font-size: 25px;
                                cursor: pointer;
                                padding-left: 5px;
                                display: block;
                            }

                            img {
                                display: block;
                                padding-right: 5px;
                            }
                        }

                        .complainBtn {
                            color: #999;
                            position: absolute;
                            right: 20px;
                        }
                    }

                    .itemBottom {
                        display: flex;
                        align-items: center;
                        color: #333;
                        font-size: 13px;

                        .orderInfo {
                            padding: 20px;
                            display: flex;
                            position: relative;
                            img {
                                display: block;
                                width: 100px;
                                height: 100px;
                                border-radius: 10px;
                                margin-right: 30px;
                            }
                            .imgThree {
                                width: 100px;
                                height: 100px;
                                border-radius: 10px;
                                margin-right: 30px;
                            }

                            .infoContent {
                                .infoName {
                                    font-size: 14px;
                                    color: #000000;
                                    padding-bottom: 10px;
                                    overflow: hidden;
                                    white-space: nowrap;
                                    text-overflow: ellipsis;
                                    max-width: 300px;
                                }

                                .infoOther {
                                    font-size: 13px;
                                    color: #999999;
                                    padding-bottom: 8px;
                                }
                            }
                        }

                        .arguments {
                            padding: 20px;
                        }

                        .argumentsName {
                            padding-bottom: 8px;
                        }
                        .payment {
                            h3 {
                                font-size: 14px;
                                font-weight: 700;
                                margin: 0;
                            }

                            .title {
                                font-size: 12px;
                                color: #999999;
                            }
                        }
                        .status{
                            font-size: 14px;
                        }
                        .operationBtn{
                            display: block;
                            color: #0C75D3;
                            text-align: center;
                            width: 100%;
                            margin: 0;
                        }
                    }
                }
            }

            .name {
                flex: 1;
                position: relative;
                display: flex;
                justify-content: center;
            }

            .price {
                width: 13%;
                text-align: center;
            }

            .num {
                width: 13%;
                text-align: center;
            }

            .arguments {
                width: 10%;
                display: flex;
                justify-content: center;
            }

            .payment {
                width: 14%;
                text-align: center;
            }

            .status {
                width: 10%;
                text-align: center;
            }

            .operation {
                width: 10%;
                text-align: center;
                .operationUploadBtn{
                    width: 102px !important;
                    height: 34px;
                    padding: 0;
                    line-height: 34px;
                    text-align: center;
                    font-weight: 700;
                    color: rgba(0, 102, 204, 0.8);
                    font-size: 14px;
                    border-color: rgba(0, 102, 204, 0.8);
                    display: block;
                    margin: 0 auto 10px !important;
                }
            }
        }
        .preview{
            position: absolute;
            width: 85px;
            height: 25px;
            padding: 0;
            text-align: center;
            border: none;
            left: 28px;
            bottom: 33px;
            background: rgba(255,255,255,.6);
            font-size: 12px;
            color: #1296DB;
            font-weight: 700;
        }
        .submitButtonGroup{
            /deep/.el-form-item__content{
                text-align: center;
                margin-left: 0 !important;
                button{
                    padding: 0;
                    width: 120px;
                    height: 35px;
                    line-height: 35px;
                    text-align: center;
                }
            }
        }
        .pagination {
            margin-top: 20px;
            text-align: right;
        }
    }
    .addressList{
        padding: 24px 15px 0;
        display: flex;
        flex-wrap: wrap;
        .addressItem{
            padding: 14px 22px;
            margin-bottom: 24px;
            margin-right: 30px;
            position: relative;
            width: 270px;
            border-radius: 8px;
            border: 2px dashed #E3E3E3;
            font-size: 14px;
            .addressBorder{
                position: absolute;
                left: 0;
                top: 0;
                width: 100%;
                height: 100%;
            }
            &.active{
                border: 2px dashed #fff;
            }
            &:nth-of-type(4n){
                margin-right: 0;
            }
            .checkBox{
                position: absolute;
                right: 22px;
                top: 14px;
            }
            .name{
                color: #000;
            }
            .tel{
                color: rgba(51, 51, 51, 0.85);
                padding: 6px 0;
            }
            .address{
                color: rgba(51, 51, 51, 0.85);
                line-height: 22px;
            }
        }
        .addItem{
            text-align: center;
            cursor: pointer;
            color: #666;
            &:hover{
                border: 2px dashed #1890FF;
            }
            .icon{
                font-size: 30px;
            }
            .addName{
                font-size: 14px;
                padding-top: 5px;
            }
        }
    }
    .electronicInvoice {
        h3 {
            padding-bottom: 15px;
            color: #000;
            font-size: 15px;
        }

        .invoiceList {
            .invoiceItem {
                border: 1px solid #ddd;
                padding: 10px 50px 10px 15px;
                border-radius: 10px;
                margin-bottom: 15px;
                display: flex;
                align-items: center;
                position: relative;

                .invoiceCheckBox {
                    padding-right: 15px;
                }

                .type {
                    font-size: 12px;
                    color: #666;
                    padding-bottom: 5px;
                }

                .name {
                    font-size: 15px;
                    color: #000;
                    padding-bottom: 5px;
                }

                .num {
                    font-size: 12px;
                    color: #333;
                }

                .edit {
                    position: absolute;
                    right: 15px;
                    top: 50%;
                    margin-top: -10px;
                    padding: 0;
                }
            }
        }

        .emailList {
            padding: 0 15px 15px;

            /deep/ .el-radio {
                margin-bottom: 15px;
                display: block;
                margin-right: 0;
            }
        }
    }
    .evaluateDialogBox {
    .evaluateItem {
        .name {
            font-size: 14px;
            color: #000;
            padding-bottom: 20px;
            font-weight: bold;
        }

        .content {
            padding-left: 20px;
            padding-bottom: 15px;
        }

        .rateItem {
            display: flex;
            align-items: center;
            padding-bottom: 15px;

            .name {
                padding: 0 20px 0 0;
                font-size: 13px;
                color: #333;
                min-width: 100px;
                font-weight: normal;
            }
        }

        .evaluateTag {
            display: flex;
            flex-wrap: wrap;

            /deep/ .el-checkbox-button {
                display: block;
                margin-right: 20px;
                margin-bottom: 15px;
            }

            /deep/ .el-checkbox-button__inner {
                border: 1px solid #dcdfe6 !important;
                border-radius: 4px;
                padding: 8px 15px;
                font-size: 13px;
                box-shadow: none;
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/views/transaction/orderManagement/printOrderList.vue